var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.tituloModal, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "padding" },
          [
            _c("div", { staticClass: "align-image" }, [
              _c("img", {
                staticClass: "senha",
                attrs: {
                  src: require("@/assets/images/assinatura.png"),
                  alt: "sicarf",
                  name: "senha"
                }
              })
            ]),
            _c("p", [
              _vm.isBA
                ? _c("span", [
                    _vm._v(
                      "Para realizar a assinatura do extrato de sentença é necessário informar a senha do seu certificado digital. Ao finalizar, todos os extratos de sentença selecionados serão assinados."
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "Para realizar a assinatura dos " +
                        _vm._s(
                          _vm.isErrataTitulo
                            ? "adendos/retificações"
                            : "títulos"
                        ) +
                        " é necessário informar a senha do seu\ncertificado digital. Ao finalizar, todos " +
                        _vm._s(_vm.isErrataTitulo ? "" : "os títulos") +
                        " selecionados serão assinados."
                    )
                  ])
            ]),
            _c("app-label", {
              staticClass: "magin",
              attrs: { label: "Senha:", required: true }
            }),
            _c("el-input", {
              staticClass: "input",
              attrs: { type: "password" },
              model: {
                value: _vm.senha,
                callback: function($$v) {
                  _vm.senha = $$v
                },
                expression: "senha"
              }
            })
          ],
          1
        )
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "margin-bottom",
                attrs: { disabled: _vm.senha.length > 3 ? false : true },
                on: {
                  click: function($event) {
                    return _vm.finalizaAssinatura()
                  }
                }
              },
              [_vm._v("Finalizar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd60c690", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd60c690","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalAssinarTitulo.vue
// module id = null
// module chunks = 